const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchLeads = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/leads/`);
    if (!response.ok) {
      throw new Error('Failed to fetch leads');
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const updateLead = async (leadId, leadData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/leads/${leadId}/`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(leadData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to update lead');
    }
    const updatedLead = await response.json();
    return updatedLead;
  } catch (error) {
    throw error;
  }
};

export const deleteLead = async (leadId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/leads/${leadId}/`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      throw new Error('Failed to delete lead');
    }
  } catch (error) {
    throw error;
  }
};

export const deleteLeads = async (leadIds) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/leads/bulk-delete/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        lead_ids: leadIds,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to delete leads');
    }
  } catch (error) {
    throw error;
  }
};